var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "9px",
    viewBox: "0 0 8 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6E209F83-2E31-44A9-B681-8B7C5C6DEDF4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DCs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CDs---GMS",
    transform: "translate(-691.000000, -152.000000)",
    fill: "#878787",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards",
    transform: "translate(0.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(428.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(103.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6,14.1363636 C13.8209139,14.1363636 14,14.3195199 14,14.5454545 L14,14.5454545 L14,15.7727273 C14,16.4505313 13.4627417,17 12.8,17 L12.8,17 L7.2,17 C6.5372583,17 6,16.4505313 6,15.7727273 L6,15.7727273 L6,14.5454545 C6,14.3195199 6.1790861,14.1363636 6.4,14.1363636 C6.6209139,14.1363636 6.8,14.3195199 6.8,14.5454545 L6.8,14.5454545 L6.8,15.7727273 C6.8,15.9986619 6.9790861,16.1818182 7.2,16.1818182 L7.2,16.1818182 L12.8,16.1818182 C13.0209139,16.1818182 13.2,15.9986619 13.2,15.7727273 L13.2,15.7727273 L13.2,14.5454545 C13.2,14.3195199 13.3790861,14.1363636 13.6,14.1363636 Z M10,8 C10.2209139,8 10.4,8.18315624 10.4,8.40909091 L10.4,8.40909091 L10.4,13.148 L11.3171573,12.210729 C11.4538408,12.0709391 11.664833,12.0534654 11.8200937,12.1583078 L11.8828427,12.210729 C12.0390524,12.370489 12.0390524,12.629511 11.8828427,12.789271 L11.8828427,12.789271 L10.2828427,14.4256346 C10.2510429,14.4581572 10.2152209,14.484059 10.1770144,14.5033403 C10.1694367,14.5071627 10.1612006,14.5109913 10.152821,14.5145371 C10.1460499,14.5173904 10.1394608,14.5199588 10.1328225,14.5223428 C10.0916462,14.5372486 10.0467601,14.5454545 10,14.5454545 L10,14.5454545 C9.9949489,14.5454545 9.9898978,14.5453573 9.98484962,14.5451628 C9.94281099,14.5434465 9.90348817,14.5354895 9.86664333,14.5221681 C9.86053922,14.5199588 9.85395012,14.5173904 9.84741785,14.5146376 C9.83879938,14.5109913 9.83056325,14.5071627 9.82248196,14.5030628 C9.7847791,14.484059 9.74895712,14.4581572 9.71715729,14.4256346 L9.71715729,14.4256346 L8.11715729,12.789271 C7.96094757,12.629511 7.96094757,12.370489 8.11715729,12.210729 C8.273367,12.0509691 8.526633,12.0509691 8.68284271,12.210729 L8.68284271,12.210729 L9.6,13.148 L9.6,8.40909091 C9.6,8.21139807 9.7371128,8.04645747 9.91938605,8.00831127 Z",
    id: "download-icon"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download-black.90a2b9876d0b72022fae80cb9133f41c.svg";
export { ForwardRef as ReactComponent };